'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_URL = exports.BASE_URL = 'https://classpass.com';
var URL_APP_IOS = exports.URL_APP_IOS = 'https://itunes.apple.com/us/app/classpass/id912947244?mt=8&uo=4';
var URL_APP_ANDROID = exports.URL_APP_ANDROID = 'https://play.google.com/store/apps/details?id=com.classpass.classpass';